import { Box } from 'components/Box';
import { CmsApiFlashCardQuizBlockData } from 'modules/cms/api/types/blocks/CmsApiFlashCardQuizBlock';

import { CmsFlashCardQuizBlockCard } from './CmsFlashCardQuizBlockCard';

type Props = {
  blockIndex: number;
  data: CmsApiFlashCardQuizBlockData;
};

export function CmsFlashCardQuizBlock({ blockIndex, data: { cards } }: Props) {
  return (
    <Box>
      {cards.map((card, index) => (
        <CmsFlashCardQuizBlockCard
          blockIndex={blockIndex} // eslint-disable-next-line react/no-array-index-key
          key={index}
          card={card}
          index={index}
        />
      ))}
    </Box>
  );
}
